const RETURN_URL_KEY = 'aipicturebookPreviewReturnUrl';

type WindowNamePayload = Record<string, unknown>;

/** 读取 window.name 中属于当前业务的结构化数据；非 JSON 内容按空对象处理。 */
function parseWindowNamePayload(): WindowNamePayload {
  try {
    const payload = JSON.parse(window.name || '{}');
    return payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
  } catch {
    return {};
  }
}

/** 统一校验返回地址，只允许 http/https，避免跳到无效协议。 */
function normalizeReturnUrl(value: unknown) {
  if (typeof value !== 'string' || !value) return '';

  try {
    const url = new URL(value, window.location.href);
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : '';
  } catch {
    return '';
  }
}

/** 从路由 query 中读取旧版 previewUrl 参数；用于兼容已经发出的旧链接。 */
export function getContentEditorPreviewUrl(value: unknown) {
  const rawUrl = Array.isArray(value) ? value[0] : value;
  return normalizeReturnUrl(rawUrl);
}

/** 预览页跳转编辑器前记录当前页面地址；使用 window.name 避免污染地址栏并支持跨域导航。 */
export function rememberContentEditorReturnUrl(url = window.location.href) {
  const returnUrl = normalizeReturnUrl(url);
  if (!returnUrl) return;

  const payload = parseWindowNamePayload();
  payload[RETURN_URL_KEY] = returnUrl;
  window.name = JSON.stringify(payload);
}

/** 编辑器需要返回预览页时读取并清理记录的地址，防止后续误用旧返回地址。 */
export function consumeContentEditorReturnUrl() {
  const payload = parseWindowNamePayload();
  const returnUrl = normalizeReturnUrl(payload[RETURN_URL_KEY]);
  if (!returnUrl) return '';

  delete payload[RETURN_URL_KEY];
  window.name = Object.keys(payload).length > 0 ? JSON.stringify(payload) : '';
  return returnUrl;
}
